// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"e927ac9d","389":"4ff6cfc8","773":"be9d590f","879":"47af392b"}[chunkId] + ".chunk.css";
};